// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container .center[data-v-8a69edba] {\n  padding: 0.2rem;\n  background-color: #f1f1f1;\n  margin-bottom: 0.2rem;\n}\n.container .center p[data-v-8a69edba] {\n    margin-right: 0.1rem;\n}\n.container .center .centerBox[data-v-8a69edba] {\n    display: flex;\n    align-items: center;\n}\n.container .footer[data-v-8a69edba] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.2rem;\n}\n", ""]);
// Exports
module.exports = exports;
